
angular.module('bmsApp.crm.prospect').controller('ProspectViewCtrl', [
	'$state',
	'$scope',
	'$timeout',
	'ActivitySvc',
	'NoteSvc',
	'ProspectSvc', function (
		$state,
		$scope,
		$timeout,
		ActivitySvc,
		NoteSvc,
		Prospect) {

		$scope.init = function () {
			var prospectId = $state.params.prospectId;
			$scope.loading = true;
			Prospect.read(prospectId)
				.then(function (response) {
					$scope.prospect = response.data.prospect;
					$scope.loading = false;
				});
		};

		$scope.note = {
			api: {}
		};

		$scope.init();

		// Action menu links

		$scope.addActivity = function () {
			// empty activity with this customer pre-selected
			var activity = {
				customer: (angular.isObject($scope.prospect.contact) && angular.isObject($scope.prospect.contact.customer)) ? $scope.prospect.contact.customer : null
			};
			ActivitySvc.showSaveModal(activity);
		};

		$scope.addNote = function () {
			var note = {
				object_type: 'prospect',
				object_id: $scope.prospect.id
			};
			NoteSvc.showSaveModal(note);
		};

		// Active tab states

		$scope.tabsActive = {
			notes: true
		};

		var setActiveTab = function (name) {
			angular.forEach($scope.tabsActive, function (value, key) {
				$scope.tabsActive[key] = String(key) === name;
			});
		};

		$scope.$on('notesUpdated', function () {
			setActiveTab('notes');
		});

		// Active tab callbacks

		$scope.tabNotes = function () {
			$scope.note.api.showNotes();
		};

	}]);
